import { GetApiData } from "../../api/general";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { OPTIONS_URL_TOKEN_REGEX } from "../../constants/enums";
import { fromWorkflowOptions } from "./workflowAdapter";

// types
import type { FieldOption, WorkflowOptionsResponse } from "../../types/components/dynamicForms";

type FormValues = Record<string, unknown>;

const hasValue = (value: unknown): value is string =>
  typeof value === "string" && value !== "";

/** Field names an optionsUrl depends on: "/cities/US/{STATE}/4" → ["STATE"]. */
export const optionsUrlDependencies = (template: string): string[] => {
  const names: string[] = [];
  template.replace(OPTIONS_URL_TOKEN_REGEX, (token, name: string) => {
    names.push(name);
    return token;
  });
  return names;
};

/** Fills each {name} token with that field's current value; null while any of them is empty. */
export const resolveOptionsUrl = (template: string, values: FormValues): string | null => {
  const dependencies = optionsUrlDependencies(template);
  const allResolved = dependencies.every((name) => hasValue(values[name]));
  if (!allResolved) return null;

  return template.replace(OPTIONS_URL_TOKEN_REGEX, (_token, name: string) =>
    encodeURIComponent(values[name] as string)
  );
};

/** GET a resolved optionsUrl. The "--Select--" placeholder is dropped. */
export const getOptions = async (path: string): Promise<FieldOption[]> => {
  const response = await GetApiData<WorkflowOptionsResponse>(API_ROUTES.DYNAMIC_FORMS.OPTIONS(path));
  return fromWorkflowOptions(response.options);
};